import e from "./DsDialog.vue_vue_type_script_setup_true_lang.js";
// src/components/DsDialog.vue
var t = e;
export { t as default };

//# sourceMappingURL=DsDialog.js.map